import { Component, OnInit, Inject } from '@angular/core';
import { DigitalFormService } from '../../digital-form.service';
import { AppService } from '../../../../../app.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-copy-digital-form',
  templateUrl: './copy-digital-form.component.html',
  styleUrls: ['./copy-digital-form.component.scss']
})
export class CopyDigitaFormComponent implements OnInit {
  formName:string;
  formId:number;
  identityServerUri:string;
  disable:boolean=false;
  constructor(private _dialogRef: MatDialogRef<CopyDigitaFormComponent>, 
     @Inject(MAT_DIALOG_DATA) private _data: any,private _appService: AppService,
     private _formService:DigitalFormService) { }

  ngOnInit() {
    this.formId = this._data.formId;

    this._appService.getApplicationConfigValue("IdentityServerUri").subscribe(result => {
      this.identityServerUri = result;
  });
  }

  onNoClick(){
    this._dialogRef.close(false);
  }
  onCopyForm(){

    if(this.formName.length==0){

    }else{
      this.disable=true;
      this._dialogRef.close(true);
      this._formService.CreateDigitalFormCopy(this.formId,this.formName).subscribe(res=>{
        console.log("Result__", res.m_Item1)
        console.log("Result__Message", res.m_Item2)
        if(res.m_Item1>0){
          
          //window.open(this.identityServerUri + 'administration/edit-digitalForm?form='+res.m_Item1); 
          window.open('edit-digitalform/'+ res.m_Item1,'_blank'); 
        }
    })
      
    }
   
  }
}
